import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'mnf-modal-confirm-domiciliation',
  templateUrl: './modal-confirm-domiciliation.component.html',
  styleUrls: ['./modal-confirm-domiciliation.component.scss']
})
export class ModalConfirmDomiciliationComponent {

  info: any;
  infoRegister: any;

  constructor(private matDialog: MatDialogRef<any>) {}

  // Frecuencia de pago
  frecuencyPay = [
    { value: 'firstDay', viewValue: 'Cada primer día del mes' },
    { value: 'halfDay', viewValue: 'Cada día 16 del mes' },
    { value: 'firstAndHalfDay', viewValue: 'Primer día del mes y día 16 del mes' }
  ];


  ngOnInit(): void {
    this.infoRegister = this.info?.r?.dd;
  }

  /** Convertir el tipo de día dependiendo al de la lista */
  getViewValue(frequencyValue: string): string {
    const matchedValue = this.frecuencyPay.find(item => item.value === frequencyValue);
    return matchedValue ? matchedValue.viewValue : frequencyValue;
  }

  /** Aceptar y cerrar modal */
  accept() {
    this.matDialog.close(true);
    window.location.reload();
  }
}
